import { enumApi } from '../api/services';

/** erpa_base IPC_OPP_GRADE.style_label 兜底（与全量 SQL 一致） */
export const OPP_GRADE_STYLE_FALLBACK: Record<string, string> = {
  S: 'error',
  A: 'warning',
  B: 'processing',
  C: 'default',
  D: 'default',
  待定: 'muted',
};

let styleByValue: Record<string, string> = { ...OPP_GRADE_STYLE_FALLBACK };
let loadPromise: Promise<void> | null = null;
let loaded = false;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach(fn => {
    try { fn(); } catch { /* ignore */ }
  });
}

/** 订阅定级色方案刷新（组件重渲染） */
export function subscribeOppGradeStyles(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isOppGradeStylesLoaded(): boolean {
  return loaded;
}

/** 从 base 拉取定级 style_label（可重复调用，单飞） */
export async function ensureOppGradeStylesLoaded(): Promise<void> {
  if (loaded && loadPromise == null) return;
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    try {
      const { list } = await enumApi.getList('IPC_OPP_GRADE');
      const next: Record<string, string> = { ...OPP_GRADE_STYLE_FALLBACK };
      (list || []).forEach(item => {
        const value = String(item.value ?? '').trim();
        if (!value) return;
        const style = String(item.style_label ?? '').trim();
        if (style) next[value] = style;
      });
      styleByValue = next;
      loaded = true;
      notify();
    } catch (e) {
      console.error('加载定级色方案失败', e);
      styleByValue = { ...OPP_GRADE_STYLE_FALLBACK };
      loaded = true;
      notify();
    } finally {
      loadPromise = null;
    }
  })();

  return loadPromise;
}

/** 定级 value → base.style_label */
export function getOppGradeStyleLabel(grade?: string | null): string {
  const g = (grade ?? '').trim();
  if (!g) return 'default';
  return styleByValue[g] || OPP_GRADE_STYLE_FALLBACK[g] || 'default';
}
